<template>
  <div
    class="project-header-fixed"
    v-if="parent.showFixedHeader && (parent.layout==='lg' || parent.layout==='xl')"
  >
    <div
      class="footer-scroll-hint"
      :class="{'animated infinite pulse show':parent.currentProjectView}"
    >&darr; SCROLL DOWN FOR MORE CONTENTS &darr;</div>
    <div id="project-header-fixed-container" :style="{'--color':parent.selectedProject.bgColor}">
      <div class="project-image-container">
        <div
          class="project"
          v-lazy:background-image="parent.getImageUrl(parent.selectedProject.cover)"
          :key="parent.getImageUrl(parent.selectedProject.cover)"
        >
          <div class="project-view-title animated">
            <span class="project-name animated">{{parent.selectedProject.name}}</span>
            <span class="project-category animated">{{parent.selectedProject.category}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
        

<script>
import ProjectNav from "../components/project-nav.vue";

export default {
  name: "project-header-fixed",
  components: {
    ProjectNav
  },
  props: ["parent"],
  mounted() {},
  data() {
    return {};
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.project-header-fixed {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 99;
}

.footer-scroll-hint {
  position: absolute;
  bottom: 1rem;
  left: 6%;
  font-size: 0.75rem;
  color: #949494;
  animation-duration: 2s;
  opacity: 1;
  transition: 0.5s opacity ease-in-out 2s;
}

#project-header-fixed-container {
  width: 100%;
  height: 100%;
  position: relative;
}
#project-header-fixed-container:after {
  content: "";
  background-color: var(--color);
  width: 50%;
  height: 100%;
  display: block;
  z-index: -1;
  position: absolute;
  top: 0;
  right: 0;
}

.project-image-container {
  width: 100%;
  height: 100%;
  height: calc(100% - 80px);
  position: relative;
  overflow: hidden;
}

.project {
  position: absolute;
  width: 100vw;
  height: 100%;
  top: 0;
  right: 0;
  background-position: right;
  background-repeat: no-repeat;
  background-size: cover;
  transition: 0.6s all ease-in-out;
}
.project-description {
  background-color: var(--color);
  padding: 0.5rem;
}

.project-view-title {
  position: absolute;
  color: white;
  top: 50%;
  left: 10%;
  display: flex;
  flex-direction: column;
  animation-duration: 0.5s;
  /* animation-delay:1s; */
  opacity: 1;
  width: 70%;
}
.project-view-title:before {
  content: "";
  position: absolute;
  width: 30px;
  height: 3px;
  top: -2rem;
  background-color: #fff;
}
.project-view-title .project-name {
  font-size: 3rem;
  /* line-height: 1.5rem; */
  font-weight: bold;
  opacity: 1;
  animation-duration: 0.3s;
  /* animation-delay: 1.5s; */
}
.project-view-title .project-category {
  font-size: 1.5rem;
  animation-duration: 0.3s;
  /* animation-delay: 1.8s; */
  text-transform: uppercase;
  opacity: 1;
}
</style>
